module.exports = __webpack_public_path__ + "img/VP-Lite_Overview-Middle_1.edcb9b1c.jpg";